import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { CircleCheckBig, CircleAlert, Info, Loader, Grip } from 'lucide-react'
import { Provider as MobXProvider } from 'mobx-react'
import { HTML5toTouch } from 'rdndmb-html5-to-touch'
import { DndProvider, Preview } from 'react-dnd-multi-backend'
import { Helmet } from 'react-helmet'
import { RouterProvider } from 'react-router'

import { Toaster } from '@/components/elements/sonner'
import { TooltipProvider } from '@/components/elements/tooltip'
import { user, UserStoreContext } from '@/stores/UserStore'

import { router } from './routes'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})
// Expose query client for use with devtools.
// See https://tanstack.com/query/v5/docs/framework/react/devtools
window.__TANSTACK_QUERY_CLIENT__ = queryClient
const renderDragPreview = ({ item, style }) => {
  const label = item?.content?.name || item?.question?.text || item?.answer?.title || 'Dragging…'
  return (
    <div
      style={style}
      className="bg-background pointer-events-none flex items-center gap-2 rounded-md border px-3 py-2 text-sm shadow-lg"
    >
      <Grip className="text-muted-foreground size-5" />
      <span className="max-w-[60vw] truncate">{label}</span>
    </div>
  )
}

function App() {
  return (
    <DndProvider options={HTML5toTouch}>
      <Preview generator={renderDragPreview} />
      <MobXProvider>
        <UserStoreContext.Provider value={user}>
          <TooltipProvider delayDuration={0}>
            <QueryClientProvider client={queryClient}>
              <Helmet titleTemplate="%s - Xverse Portal" defaultTitle="Xverse Portal">
                <meta name="description" content="Xverse Portal" />
              </Helmet>

              <RouterProvider router={router} />

              <Toaster
                icons={{
                  success: <CircleCheckBig className="text-success size-5" />,
                  info: <Info className="text-primary size-5" />,
                  warning: <CircleAlert className="text-warning size-5" />,
                  error: <CircleAlert className="text-warning size-5" />,
                  loading: <Loader className="text-primary size-5 animate-spin" />,
                }}
              />
            </QueryClientProvider>
          </TooltipProvider>
        </UserStoreContext.Provider>
      </MobXProvider>
    </DndProvider>
  )
}

export default App
